import { blue, red, textMuted, white } from '@/theme/colors'
import { Link } from 'react-router-dom'
import styled from 'styled-components'

export const Card = styled.div`
	background-color: ${white};
	border-radius: 12px;
	box-shadow: 0 1px 3px rgba(0, 0, 0, 0.08);
	padding: 1.5rem;
	display: flex;
	flex-direction: column;
	min-width: 0;
`

export const Head = styled.div`
	display: flex;
	flex-direction: column;
	gap: 0.25rem;
	margin-bottom: 1rem;
`

export const Count = styled.span`
	font-size: 2.25rem;
	font-weight: 700;
	color: ${blue};
	line-height: 1;
`

export const Label = styled.span`
	font-size: 0.95rem;
	font-weight: 500;
	color: ${textMuted};
`

export const List = styled.div`
	display: flex;
	flex-direction: column;
	flex: 1;
`

export const RowLink = styled(Link)<{ $deleted?: boolean }>`
	display: flex;
	align-items: baseline;
	justify-content: space-between;
	gap: 0.75rem;
	padding: 0.55rem 0.35rem;
	border-bottom: 1px solid ${textMuted}14;
	text-decoration: none;
	background-color: ${({ $deleted }) => ($deleted ? `${red}0d` : 'transparent')};
	border-radius: 6px;

	&:hover {
		background-color: ${blue}0d;
	}
`

export const RowText = styled.div`
	min-width: 0;
	display: flex;
	flex-direction: column;
	gap: 0.1rem;
`

export const RowPrimary = styled.span`
	color: ${blue};
	font-weight: 600;
	font-size: 0.92rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const RowSecondary = styled.span`
	color: ${textMuted};
	font-size: 0.8rem;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
`

export const RowMeta = styled.span`
	color: ${textMuted};
	font-size: 0.8rem;
	white-space: nowrap;
	flex-shrink: 0;
`

export const DeletedTag = styled.span`
	display: inline-block;
	margin-left: 0.4rem;
	padding: 0.05rem 0.35rem;
	border-radius: 5px;
	background-color: ${red};
	color: ${white};
	font-size: 0.65rem;
	font-weight: 700;
	vertical-align: middle;
`

export const Empty = styled.div`
	color: ${textMuted};
	font-size: 0.88rem;
	padding: 0.75rem 0.35rem;
`

export const SeeAll = styled(Link)`
	margin-top: 0.85rem;
	align-self: flex-end;
	color: ${blue};
	font-weight: 600;
	font-size: 0.88rem;
	text-decoration: none;

	&:hover {
		text-decoration: underline;
	}
`
